import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/courses/${id}/roundtables-criteria`, payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/updateRTsCriteria.js